import can from 'can';
import DropdownSearch from 'components/dropdown/dropdown-container/dropdown-search';

export default can.Map.extend({
    value: null,
    tags: [],
    define: {
        items: {
            Type: can.List,
            set(items) {
                let tags = this.attr('tags');
                let configured = false;
                if (tags && tags.length) {
                    tags.forEach((tag) => {
                        items.forEach((item) => {
                            if (!configured && item.key === tag.key) {
                                this.attr('value', item);
                                configured = true;
                            }
                        });
                    });
                }
                if (!configured) {
                    items.forEach((item) => {
                        if (item.selected) {
                            this.attr('value', item.key);
                        }
                    });
                }

                return items;
            },
        },
        search: {
            Type: DropdownSearch,
            Value: null,
        },
    },
});
